<template>
  <div>
    <div class="inqueryResult clearfix">
      <label class="title-line"></label>
      <span class="title">转账</span>
    </div>
    <el-card class="box-card" style="height: 550px; margin-top: 20px;">
      <el-form label-width="140px">
        <el-row>
          <el-form-item label="市场：">
            <span>{{ transferData.marketName }}</span>
          </el-form-item>
          <el-form-item label="付款账号：">
            <span>{{$key.keyFilter(transferData.channelCode, 'myAccount', 'bankName').name}} ({{exAccountNo(transferData)}})</span>
          </el-form-item>
          <el-form-item label="可转账金额：">
            <span style="color: #ff5255;">{{ transferableAmount }}元</span>
          </el-form-item>
          <el-form-item label="收款账号：">
            <el-input class="input" v-model="receiverExAccountNo" placeholder="请输入" @blur='searchOtherAccount(receiverExAccountNo)'></el-input>
            <img :src="user" alt="" class="user" @click="transferRecord">
          </el-form-item>
          <el-form-item label="收款账户名：">
            <el-input class="input" v-model="form.receiverBaseAccountName" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="转账金额：">
            <el-input class="input" v-model="form.applyAmount" clearable placeholder="请输入"></el-input>
            <span class='amount'>元</span>
          </el-form-item>
          <el-form-item label="转账备注：">
            <el-input type="textarea" v-model='form.tradeRemark' clearable placeholder="请输入" class="input"></el-input>
          </el-form-item>
          <div style="margin-left: 140px;">
            <el-button @click="cancel">取消</el-button>
            <el-button class="sure" @click="sure">确认转账</el-button>
          </div>
        </el-row>
      </el-form>
    </el-card>
    <el-dialog title="最近转账" :visible.sync="isTransfer" width="600px" :before-close="closeTransfer" :close-on-click-modal="false">
      <div class="link-top"></div>
      <ul class="bank-card" id="oUl">
        <li v-for="item in lateTransferData" :key='item.receiverExAccountNo'>
          <div class="circular"></div>
          <img src="@/assets/bank.png" alt="" class="bank" >
          <div class="bank-text">{{ item.receiverBaseAccountName }}</div>
          <div class="number">{{ item.receiverBaseAccountNo.replace(/\s/g, '').replace(/(.{4})/g, "$1 ") }}</div>
        </li>
      </ul>
      <div style="text-align: center">
        <el-button class="sure-l" @click="bankTransfer">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="passwordHidden ? '请输入支付密码' : '转账申请'" :visible.sync="dialogVisible" width="450px" :before-close="close" :close-on-click-modal="false">
      <div class="link-top"></div>
      <el-form :inline="true" label-width="100px" class="center">
        <div v-if="passwordHidden">
          <el-row style="width: 400px;">
            <el-form-item label="" style="margin-left: 100px;">
              <el-input :type="isDesen ? 'password' : ''" v-model='password' placeholder='请输入6位支付密码' style="width: 230px" class="input" @input="checkPass(password, 'password')"></el-input>
              <div @click="select" class="tips">
                <img src="@/assets/password_hide.png" alt="" class="password" v-if="isDesen">
                <img src="@/assets/password_visual.png" alt="" class="password" v-if="!isDesen">
              </div>
            </el-form-item>
            <el-button class="sureTx" @click="sureTransfer" :loading="loading" style="width: 230px;">确认转账</el-button>
            <div class="btn">
              <span class="left" @click="cancel">取消转账</span>
              <span class="right" @click="forgetPass">忘记密码?</span>
            </div>
          </el-row>
        </div>
        <div style="text-align: center" v-else>
          <img :src="success" alt="">
          <div class='passSuss'>转账申请已提交，请耐心等候审核</div>
          <el-button class="sure-l" @click="cancel">确定</el-button>
        </div>
      </el-form>
    </el-dialog>
    <forget-pass @closeMain="closeMain" v-if="isDisplay" editType='2'></forget-pass>
    <set-pass @closeMain="closeMain" v-if="isSetDisplay" :userId="userId"></set-pass>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
import api from '@/api'
import CryptoJS from 'crypto-js'
import success from '@/assets/success.png'
import user from '@/assets/user.png'
import forgetPass from '@/components/forget-pass'
import setPass from '@/components/set-pass'
export default {
  name: 'fs-withdrawal',
  components: {
    forgetPass,
    setPass
  },
  props: {
    transferData: {
      type: Object
    }
  },
  filters: {
    amount (e) {
      var f1 = parseFloat(e)
      if (isNaN(f1)) {
        return false
      }
      var f2 = Math.round(e * 100) / 100
      var s = f2.toString()
      var rs = s.indexOf('.')
      if (rs < 0) {
        rs = s.length
        s += '.'
      }
      while (s.length <= rs + 2) {
        s += '0'
      }
      return s
    },
    replace (e) {
      return e.substring(e.length - 4)
    }
  },
  data () {
    return {
      loading: false,
      success: success,
      user: user,
      dialogVisible: false,
      passwordHidden: true,
      password: '',

      isDisplay: false,
      isSetDisplay: false,

      // 转账记录
      isTransfer: false,
      lateTransferData: [],
      idx: '',

      // 密码脱敏显示
      isDesen: true,

      // 用户id
      userId: Cookie.getJSON('AppUserInfo').userId,

      // 校验规则
      companyRules: [
        { name: 'receiverBaseAccountNo', message: '请输入对方账号' },
        { name: 'receiverBaseAccountName', message: '请输入对方账户名' },
        { name: 'applyAmount', message: '请输入转账金额' },
      ],

      // 提交表单数据
      form: {
        // 业务类型
        businessType: '301',
        // 渠道
        channelCode: '',
        // 转账金额
        applyAmount: '',
        // 交易密码
        password: '',
        // 付款附属账户号
        payerBaseAccountNo: '',
        // 对方账号
        receiverBaseAccountNo: '',
        // 对方账户名称
        receiverBaseAccountName: '',
        // 交易备注
        tradeRemark: '',
      },
      // 可提现金额
      transferableAmount: '',
      // 外部账户
      receiverExAccountNo: ''
    }
  },
  created () {
    this.baseAccountBalance(this.transferData.baseAccountNo)
  },
  methods: {
    // 密码脱敏显示
    select () {
      this.isDesen = !this.isDesen
    },

    // 取消提现
    cancel () {
      this.$emit('done', true)
    },

    // 关闭弹窗
    handleClose () {
      this.$emit('done')
    },

    // 关闭忘记密码弹窗
    close () {
      this.dialogVisible = false
    },

    // 关闭最近转账弹窗
    closeTransfer () {
      this.isTransfer = false
    },

    // 忘记密码
    forgetPass () {
      this.isDisplay = true
    },

    closeMain (e) {
      this.isDisplay = false
      this.isSetDisplay = false
    },

    // 判断是否是数字
    checkPass (v, k) {
      if (!isNaN(v)) {
        this[k] = v
      } else {
        this[k] = ''
      }
    },
    // 确认
    sure () {
      this.form.channelCode = this.transferData.channelCode
      this.form.payerBaseAccountNo = this.transferData.baseAccountNo
      if (this.$utils.checkEmptyRules(this.form, this.companyRules)) {
        return
      }
      if (this.form.applyAmount > this.transferableAmount) {
        this.$message.error('转账金额不能大于可划转金额')
      } else {
        this.password = ''
        this.dialogVisible = true
      }
    },

    // 查询最近30天转账记录
    async transferRecord () {
      let that = this
      this.isTransfer = true
      this.lateTransferData = (await api.myAccount.recentTradeAccount()).data
      setTimeout(() => {
        let oUl = document.getElementById('oUl')
        let aLi = oUl.getElementsByTagName('li')
        let aCircular = oUl.getElementsByClassName('circular')
        for (let i = 0; i < aLi.length; i++) {
          aLi[i].onclick = function () {
            for (let j = 0; j < aLi.length; j++) {
              aLi[j].className = ''
              aCircular[j].className = 'circular'
            }
            aLi[i].className = 'change'
            aCircular[i].className = 'circular active'
            that.idx = i
          }
        }
      }, 10)
    },

    // 确定转账
    bankTransfer () {
      this.receiverExAccountNo = this.lateTransferData[this.idx].receiverExAccountNo
      this.form.receiverBaseAccountNo = this.lateTransferData[this.idx].receiverBaseAccountNo
      this.form.receiverBaseAccountName = this.lateTransferData[this.idx].receiverBaseAccountName
      // this.searchOtherAccount(this.receiverExAccountNo)
      this.isTransfer = false
    },

    // 查询对方账号
    async searchOtherAccount (receiverExAccountNo) {
      const data = (await api.myAccount.queryPlatformAccountByExAccountNo(JSON.stringify(receiverExAccountNo))).data
      this.form.receiverBaseAccountName = data.baseAccountName
      this.form.receiverBaseAccountNo = data.baseAccountNo
    },

    // 确认划转
    async sureTransfer () {
      this.form.password = this.encryptByAes(this.password)
      if (this.userId) {
        const data = (await api.myAccount.checkHasPsw({ userId: this.userId })).data
        if (data === '1') {
          if (this.form.password === '') {
            this.$message.error('请输入支付密码')
          } else {
            this.loading = true
            api.myAccount.applyTransferOrWithdraw(this.form).then((res) => {
              this.$message.success('成功')
              this.passwordHidden = false
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        }
        if (data === '0') {
          this.$confirm('您还没有设置交易密码, 是否设置?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.isSetDisplay = true
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消设置'
            })
          })
        }
      }
    },

    // 密码加密
    encryptByAes (psw) {
      let key = CryptoJS.enc.Utf8.parse('APP7apecSQznwPWD') // 秘钥
      let iv = CryptoJS.enc.Utf8.parse('307znw65426apecb') // 偏移量
      let srcs = CryptoJS.enc.Utf8.parse(psw)
      var encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
      return encrypted.ciphertext.toString().toUpperCase()
    },

    // 付款账户
    exAccountNo (row) {
      let baseAcc = row.exAccountNo.replace(/^([a-zA-Z0-9]{4})\d+(\d{4})$/, '$1 **** $2')
      return baseAcc
    },

    // 查询可转账金额
    async baseAccountBalance (baseAccountNo) {
      const data = (await api.myAccount.baseAccountBalance(JSON.stringify(baseAccountNo))).data
      this.transferableAmount = data.transferableAmount
    },
  },
}
</script>

<style lang="scss" scoped>
.password {
  width: 22px;
  height: 10px;
  float: left;
}
.tips {
  position: absolute;
  top: 16px;
  left: 198px;
  width: 25px;
  height: 25px;
}
.circular {
  width: 11px;
  height: 11px;
  border: 1px solid #ccc;
  border-radius: 50%;
  margin-top: 17px;
  margin-left: 17px;
}
.active {
  border: none;
  border: 4px solid #3b88fd;
}
.user {
  position: absolute;
  width: 22px;
  height: 25px;
  left: 230px;
  top: 13%;
  cursor: pointer;
}
.el-form-item {
  margin-bottom: 8px;
}
.inqueryResult{
  margin-top: 15px; // 与表格的margin保持一致
  height: 32px;
  line-height: 32px;
  .title-line {
    width:4px;
    height:14px;
    background-color:#f8bd47;
    display:inline-block
  }
  .title {
    margin-left: 10px;
    font-size: 16px;
    font-weight: 600;
    color: #161616;
  }
}
.gobal-form{
  .el-input, .el-input__inner{
    width:217px !important;
  }
  div.input-val{
    display:inline-block;
    width:217px;
  }
}
.input {
  width: 260px;
  height: 32px;
  line-height: 32px;
}
.amount {
  margin-left: 10px;
  color: #666666;
}
.sure {
  margin: 20px 0 0 140px;
  // width: 160px;
  background: #f8bd47;
  color: #fff;
  border: none;
}
.sure-l {
  width: 260px;
  background: #f8bd47;
  color: #fff;
  margin-top: 40px;
}
.sureTx {
  margin: 20px 0 0 100px;
  width: 160px;
  background: #f8bd47;
  color: #fff;
  border: none;
}
.link-top {
  width: 100%;
  height: 1px;
  border-top: solid #f8bd47 1px;
  margin-bottom: 30px;
}
.bank-card {
  height: 200px;
  overflow: hidden;
  overflow-y: auto;
  margin-left: -37px;
}
.bank-card li {
  width: 100%;
  height: 45px;
  line-height: 45px;
  border-bottom: 1px solid #f2f2f2;
}
.bank-card li div, .bank {
  float: left;
}
.bank {
  margin-top: 10px;
  margin-left: 20px;
}
.bank-text {
  margin-left: 7px;
  height: 43px;
  width: 240px;
  font-weight: 600;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.bank-card li .number {
  font-size: 14px;
  color: #666666;
  float: right;
  height: 43px;
  margin-right: 15px;
}
.bank-card .change {
  background: #fafcfe;
  border: 1px solid #8cb5de;
}
.btn {
  width: 55%;
  margin-left: 27%;
  margin-top: 30px;
  span {
    color: #5ca7ff;
    cursor:pointer;
  }
  .left {
    float: left;
  }
  .right {
    float: right;
  }
}
.passSuss {
  font-size: 14px;
  color: rgba(51, 51, 51, 0.94);
  font-family: '微软雅黑';
  font-weight: normal;
  font-stretch: normal;
  margin-top: 20px;
  letter-spacing: 0px;
}
li {
  list-style: none;
}

</style>
